import React from 'react';
import { useDispatch } from 'react-redux';
import { updateShowSetMinDurationsModal } from '../../../../actions/modal';
import BottomAccordion from '../../../shared/bottom-accordion/content';
import { Icon } from 'semantic-ui-react';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function ViewReportsRightBottomPanel(props) {
  const dispatch = useDispatch();

  const setMinDurations = () => {
    if (props.fetchingReports) {
      return;
    }
    dispatch(updateShowSetMinDurationsModal(true));
  };

  const generateMinDurationMarkUp = () => {
    let setMinDurationsButton = '';

    setMinDurationsButton = (
      <button
        type="button"
        data-clipboard-text="Set minimum durations"
        className="ui labeled icon button hide-on-tablet-mobile"
        onClick={setMinDurations}
        style={{ cursor: props.fetchingReports ? 'default' : 'pointer' }}
      >
        <Icon name="wait" style={{ marginTop: '-2px' }} />
        {APP.LANGUAGE.MainReport.SetMinDurations}
      </button>
    );

    return (
      <div>
        <p>{htmlToReactParser.parse(xss(APP.LANGUAGE.MainReport.InfoExplanation))}</p>
        <p className="mrbnull">
          <span className="color-info" />
        </p>
        {setMinDurationsButton}
      </div>
    );
  };

  const aboutThisPageMarkup = (
    <div>
      <i className="ui icon info circle mrls mrrnull text-size-xl fr mrbs" />
      <p
        dangerouslySetInnerHTML={{
          __html: APP.LANGUAGE.MainReport.InfoPartOne,
        }}
      />
      <p
        dangerouslySetInnerHTML={{
          __html: APP.LANGUAGE.MainReport.InfoPartTwo,
        }}
      />
      <p
        dangerouslySetInnerHTML={{
          __html: APP.LANGUAGE.MainReport.InfoPartThree.replace(
            '##hrefLink##',
            APP.EXTERNAL_LINKS.Report.HelpAboutReportPage
          ),
        }}
      />
    </div>
  );

  const options = [
    {
      title: 'Set minimum durations',
      as: 'custom',
      content: generateMinDurationMarkUp(),
    },
    {
      title: 'About this page',
      as: 'custom',
      content: aboutThisPageMarkup,
    },
  ];
  const activeIndexOfPage = window.localStorage.getItem(`reportActiveIndex-${props.userId}`);

  return (
    <BottomAccordion
      options={options}
      userId={props.userId}
      pagePrefix="reportActiveIndex"
      activeIndex={
        (!!activeIndexOfPage && JSON.parse(activeIndexOfPage)) || [
          options[options.length - 1].title.split(' ').join(''),
        ]
      }
    />
  );
}
